import { StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import { useSelector } from "react-redux";
import { getFlagTableRows, getDisplayInvolvements } from "./flagUtils";

const flagInJailDetailsHeaders = [
  { key: "flag", text: "Flag" },
  { key: "summaryDescription", text: "Summary Description" },
  { key: "relatedRecordSummary", text: "Related Record Summary" },
];

const FlagInJailDetails = () => {
  const bookings = useSelector((state) => state?.bookings?.bookings);
  const jacketFlags = useSelector((state) => state?.bookings?.jacketFlags);
  const rows = getFlagTableRows(
    getDisplayInvolvements(bookings, jacketFlags),
    "FLAGTYPES_INJAIL",
    "In Jail",
    bookings,
  );

  return (
    <>
      <StyledGridRow justify={"space-between"}>
        <StyledGridCol></StyledGridCol>
        <StyledGridCol>
          <Button>Delete</Button>
        </StyledGridCol>
      </StyledGridRow>

      <Table headers={flagInJailDetailsHeaders} data={rows} style={{ marginTop: "15px" }} />
    </>
  );
};
export default FlagInJailDetails;
